﻿import { mutations } from "@/graphql";
import { useMutation } from "@apollo/client/react";
import { enqueueSnackbar } from "notistack";
import { useCallback } from "react";
export function useDeletePublicToken(
  onCompleted: (data?: any) => void = () => {},
  onError: (error?: any) => void = () => {},
) {
  const [deletePublicToken, { loading }] = useMutation<any>(
    mutations.deletePublicToken,
    {
      onCompleted,
      onError: (err) => {
        onError(err);

        enqueueSnackbar(err.message, {
          variant: "error",
        });
      },
      refetchQueries: ["GetPublicToken"],
      errorPolicy: "all",
    },
  );

  const deleteToken = useCallback(() => {
    deletePublicToken().then();
  }, [deletePublicToken]);

  return {
    delete: deleteToken,
    deleting: loading,
  };
}
